module.exports = __webpack_public_path__ + "img/sjs-3.a71e6d72.png";